var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.839,
    height: 21.967,
    viewBox: "0 0 25.839 21.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M10.348,21.967H3.873V11.619H0L12.889,0l12.95,11.619H21.967V21.967H15.492V14.221H10.348Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3828bd4b3c09c0fb93cadd7099bc1e5c.svg";
export { ForwardRef as ReactComponent };